import { useCustomCacheUpdate } from '@/hooks/dataHelpers/useCustomCacheUpdate';
import { useCallback } from 'react';

export const useOrgCacheUpdate = () => {
  const { updateQueryCacheData } = useCustomCacheUpdate({});

  const updateOrgCacheWithData = useCallback(
    (fieldValue: any, orgId: string | number, responseData: any, fieldName: string) => {
      if (!fieldValue || !orgId || !fieldName) {
        console.warn('updateOrgCacheWithData: Missing fieldValue, orgId, or fieldName');
        return;
      }

      updateQueryCacheData(
        [
          {
            resource: 'orgs',
            action: 'detail',
            id: orgId,
            callbackFn: ({ queryKeys, queryClient }) => {
              queryKeys?.forEach((queryKey: any) => {
                queryClient.setQueryData(queryKey, (cacheData: any) => {
                  if (!cacheData) return cacheData;

                  // Update only the specific field in cache
                  return {
                    ...cacheData,
                    data: {
                      ...cacheData.data,
                      [fieldName]: fieldValue,
                    },
                  };
                });
              });
            },
          },
        ],
        responseData
      );
    },
    [updateQueryCacheData]
  );

  return {
    updateOrgCacheWithData,
  };
};
